/*
 * @Description: 临调业务接口
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2021/1/25 16:02
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  // E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BUSI_WEB
} = e6ModuleOrderWaybillProcessApi;

// 询价调度查询运单详情
export function fetchInquiryInfoWaybillDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/getWaybillDetailById`,
    method: "get",
    params
  });
}
// 询价保存
export function fetchInquirySave(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/save`,
    method: "post",
    data
  });
}
// 确认合作
export function confirmCooperation(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/confirmCooperation`,
    method: "post",
    data
  });
}
// 查询询价详情（重新询价用）
export function fetchInquiryDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/detail`,
    method: "post",
    data
  });
}
